import React from 'react'
import '../../navbar.css'
import Brand from '../../assets/images/logos/logo2.png'
import Logo from '../../assets/images/logos/logo.png'
// import { Link } from "react-router-dom"
//Navbar
const Navbar = () => {
    const gotoHome = () => {
        if (localStorage.getItem('allowed') === '1') {
            window.location.href = '/home'
        }
        else {
            window.location.href = '/';
        }
    }
    const gotoSignIn = () => {
        window.location.href = '/signin'
    }
    return (
        <div className="nav">
            <div className="brand">
                {/* Brand */}
                <img src={Brand} alt="brand-logo" onClick={gotoHome} style={{ cursor: 'pointer' }} />
            </div>
            <div className="logo">
                {/* Logo */}
                <img src={Logo} alt="logo" onClick={gotoHome} style={{ cursor: 'pointer' }} />
            </div>
            <button className="btn1" onClick={gotoSignIn}>Sign In</button>

        </div>
    )
}

export default Navbar;